module.exports = __webpack_public_path__ + "img/refresh.5621aaae.svg";